// extracted by mini-css-extract-plugin
export var growableInput = "_7p-0";
export var tagContainer = "_7p-2";
export var textInput = "_7p-1";